//引入刚才的http.js文件
import https from './http.js';

let apiFun = {};

apiFun.get = function(url, params) {
    return https.get(url, params)
}

apiFun.post = function(url, params) {
    return https.post(url, params)
}

apiFun.upload = function(url, formData) {
    return https.upload(url, formData)
}

apiFun.login = function(params) {
    let baseURLs = sessionStorage.getItem('baseURL') || '';
    if (!baseURLs) {
        sessionStorage.setItem("baseURL", baseURLs)
    }
    return https.post('/api/login_pc', params)
}

apiFun.getMathCode = function() {
    return https.get('/api/getMathCode', {})
}

apiFun.sendSmsCode = function(params) {
    return https.post('/api/authCodeSend', params)
}

apiFun.register = function(params) {
    let baseURLs = sessionStorage.getItem('baseURL') || '';
    if (!baseURLs) {
        sessionStorage.setItem("baseURL", baseURLs)
    }
    return https.post('/api/register', params)
}

export default apiFun;



// WEBPACK FOOTER //
// ./src/http/api.js